if (!Array.prototype.first) {
    Array.prototype.first = function () {
        if (this.length <= 0) {
            return undefined;
        }
        return this[0];
    };
}
if (!Array.prototype.penultimate) {
    Array.prototype.penultimate = function () {
        if (this.length <= 1) {
            return undefined;
        }
        return this[this.length - 2];
    };
}
if (!Array.prototype.last) {
    Array.prototype.last = function () {
        if (this.length <= 0) {
            return undefined;
        }
        return this[this.length - 1];
    };
}
if (!Array.prototype.any) {
    Array.prototype.any = function (callbackfn, thisArg) {
        if (callbackfn) {
            return this.filter(callbackfn).any();
        }
        return this.length > 0;
    };
}
if (!Array.prototype.remove) {
    Array.prototype.remove = function (item) {
        let indexToRemove;
        this.forEach((x, index) => {
            if (x === item) {
                indexToRemove = index;
            }
        });
        if (indexToRemove != undefined) {
            this.splice(indexToRemove, 1);
        }
    };
}
if (!Array.prototype.distinct) {
    Array.prototype.distinct = function (matcher) {
        return this.filter((item, index, self) => {
            let firstIndex = self.findIndex((x) => {
                let y = (matcher) ? matcher(x, item) : x;
                return y === item;
            });
            return firstIndex === index;
        });
    };
}
if (!Array.prototype.equals) {
    Array.prototype.equals = function (array) {
        // if the other array is a falsy value, return
        if (!array)
            return false;
        // compare lengths - can save a lot of time 
        if (this.length != array.length)
            return false;
        for (var i = 0, l = this.length; i < l; i++) {
            // Check if we have nested arrays
            if (this[i] instanceof Array && array[i] instanceof Array) {
                // recurse into the nested arrays
                if (!this[i].equals(array[i]))
                    return false;
            }
            else if (this[i] != array[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
    };
    // Hide method from for-in loops
    Object.defineProperty(Array.prototype, "equals", { enumerable: false });
}
//# sourceMappingURL=array.extensions.js.map